import Win from './Window';
import { GetBy } from '../core/Element';
import { gsap, Power2, Power4 } from "gsap";

class ZoomImage extends Win {

  constructor(__container) {
    super(__container, "zoom");
   
    this.figure = GetBy.selector("figure", this.container)[0];
    this.thumb = GetBy.selector("img", this.container)[0];
    this.zoom = GetBy.selector("img", this.container)[1];
  }

  show(__item) {
    this.thumb.src = __item.src;
    const images = __item.dataset.src.split(",");
    this.zoom.src = images[images.length-1];
    super.show();
  }

  show__effect(__d = 0) {
    gsap.to(this.figure, {scaleX:1, scaleY:1, duration:.3, ease: Power4.easeOut});
    gsap.to(this.container, {opacity:1, duration:.2, ease: Power2.easeIn, onComplete:()=>{this.afterShow()}});
  }

  hide__effect(__d = 0) {
    gsap.to(this.figure,{scaleX:.8, scaleY:.8, duration:.4, ease:Power2.easeIn});
    gsap.to(this.container,{opacity:0, duration:.2, ease:Power2.easeIn, onComplete:()=>{this.afterHide();}});
  }

  afterHide() {
    this.thumb.src = "/assets/images/blank.png";
    this.zoom.src = "/assets/images/blank.png";

    super.afterHide();
  }

  directHide() {
    gsap.set(this.container,{opacity:0});
    super.directHide();
  }
}

export const WinZoom = new ZoomImage(GetBy.id("ZoomImage"));

